import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const AggregateMiller = ({
  isAggregateReport=false,
  classes,
  schools,
  selectedSchool,
  selectedClass,
  onClassMillerSelection,
  onSchoolMillerSelection,
  onAggregateSchoolMillerOpened,
  onAggregateSchoolMillerClosed,
  onAggregateClassMillerOpened,
  onAggregateClassMillerClosed,
  isDisabled
}) => {

  const {t} = useTranslation("reports_sidebar")

  // Class styles
  const inactiveClassSelect = (classes.length == 0 || classes.length == 1);
  const classSelectStyle = cx({
    "reportsAggregateSelect": true,
    "reportsInactiveSelect": inactiveClassSelect,
  });
  const classSelectPrefixStyle = cx({
    "reportsAggregateSelect": !inactiveClassSelect,
    "reportsInactiveSelect": inactiveClassSelect,
  });

  // School styles
  const inactiveSchoolSelect = (schools.length == 0 || schools.length == 1);
  const schoolSelectStyle = cx({
    "reportsAggregateSelect": true,
    "reportsSingleSelect": isAggregateReport,
    "reportsInactiveSelect": inactiveSchoolSelect,
  });
  const schoolSelectPrefixStyle = cx({
    "reportsAggregateSelect": !inactiveSchoolSelect,
    "reportsInactiveSelect": inactiveSchoolSelect,
  });

  // TODO, extend global dropdown component to accomodate these styles and get rid of "select"
  return (
    <div className="aggregateMiller">
        <Select
          menuPlacement="auto"
          className={schoolSelectStyle}
          classNamePrefix={schoolSelectPrefixStyle}
          options={schools}
          onMenuOpen={() => onAggregateSchoolMillerOpened()}
          onMenuClose={() => onAggregateSchoolMillerClosed()}
          value={selectedSchool}
          onChange={onSchoolMillerSelection}
          isDisabled={isDisabled}
          placeholder={t("Select...")}
        />
        {!isAggregateReport && <Select
          menuPlacement="auto"
          className={classSelectStyle}
          classNamePrefix={classSelectPrefixStyle}
          options={classes}
          value={selectedClass}
          onMenuOpen={() => onAggregateClassMillerOpened()}
          onMenuClose={() => onAggregateClassMillerClosed()}
          onChange={onClassMillerSelection}
          isDisabled={isDisabled}
          placeholder={t("Select...")}
        />}
    </div>
  )
}

export default AggregateMiller;